module.exports = __webpack_public_path__ + "static/img/19b.16d9e90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/19b.png
// module id = GGR5
// module chunks = 1